"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { toast } from "sonner";

/**
 * Fires a persistent Sonner toast when draft mode is active, giving the editor
 * a visible indicator and a one-click way to exit the preview.
 */
export const DraftModeToast = () => {
  const { push } = useRouter();

  useEffect(() => {
    toast("Draft preview", {
      description: "You are viewing unpublished content.",
      duration: Infinity,
      dismissible: false,
      action: {
        label: "Exit preview",
        onClick: () => push("/api/disable-draft"),
      },
    });
  }, [push]);

  return null;
};
